import React from 'react';
import _ from 'lodash';

import {
  CustomerChatWidgetDocument,
  OrderChatMessagesWidgetDocument,
  Partner_ReturnAuthorizationChatMessagesWidgetDocument,
  useSendChatMessageAsCustomerMutation,
  useSendChatMessageMutation
} from 'generated/graphql';

import * as types from './types';



export function useSendOrderChatMessage(orderId: string) {
  const [fnMutate, tuple] = useSendChatMessageMutation({
    refetchQueries: [
      {
        query: OrderChatMessagesWidgetDocument,
        variables: { orderId }
      }
    ]
  });



  const fnWrappedMutate = React.useCallback(async (formState: types.IFormState) => {
    await fnMutate({
      variables: {
        input: {
          content: formState.content,
          orderId
        }
      }
    });
  }, [
    fnMutate,
    orderId
  ]);



  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}



export function useSendChatMessageAsCustomer({
  orderId, returnAuthorizationId
}: {
  orderId?: string;
  returnAuthorizationId?: string;
}) {
  const [fnMutate, tuple] = useSendChatMessageAsCustomerMutation({
    refetchQueries: [
      {
        query: CustomerChatWidgetDocument,
        variables: {
          id: orderId || returnAuthorizationId,
          queryOrder: !_.isNil(orderId)
        }
      }
    ]
  });



  const fnWrappedMutate = React.useCallback(async (formState: types.IFormState) => {
    await fnMutate({
      variables: {
        content: formState.content,
        orderId,
        returnAuthorizationId
      }
    });
  }, [
    fnMutate,
    orderId,
    returnAuthorizationId
  ]);



  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}



export function useSendReturnAuthorizationChatMessage(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useSendChatMessageMutation({
    refetchQueries: [
      {
        query: Partner_ReturnAuthorizationChatMessagesWidgetDocument,
        variables: { returnAuthorizationId }
      }
    ]
  });



  const fnWrappedMutate = React.useCallback(async (formState: types.IFormState) => {
    await fnMutate({
      variables: {
        input: {
          content: formState.content,
          returnAuthorizationId
        }
      }
    });
  }, [
    fnMutate,
    returnAuthorizationId
  ]);



  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
